module.exports = __webpack_public_path__ + "/images/pin-selected.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/pin-selected.svg
// module id = 624
// module chunks = 0